import Cookies from "universal-cookie";

export default function cookieValue() {
  const cookies = new Cookies();
  const userSession = cookies.get("user_session");
  // console.log(userSession);
  if (userSession === undefined || userSession === null) {
    return false;
  } else {
    return userSession;
  }
}
